var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    _vm._b(
      {
        attrs: {
          persistent: "",
          "max-width": "500px",
          "disable-close": _vm.loading,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
            },
            proxy: true,
          },
          {
            key: "alert",
            fn: function () {
              return [
                _c(
                  "v-alert",
                  {
                    key: "alert",
                    staticClass: "my-0",
                    attrs: { outline: "", type: "error", value: _vm.showAlert },
                  },
                  [
                    _c("div", { staticClass: "primary--text" }, [
                      _vm._v(
                        "\n        " + _vm._s(_vm.alertMessage) + "\n      "
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "The alias " +
                      _vm._s(_vm.synonymName) +
                      " will be created as a separate data source along with all specimen and survey data\n      associated with it."
                  ),
                ]),
                _vm._v(" "),
                _c("v-checkbox", {
                  attrs: {
                    color: "info",
                    label: "Assign to a location",
                    "persistent-hint": "",
                    hint: "The alias will automatically be assigned to an existing or new location based on its name.",
                    disabled: _vm.loading,
                  },
                  model: {
                    value: _vm.assignToLocation,
                    callback: function ($$v) {
                      _vm.assignToLocation = $$v
                    },
                    expression: "assignToLocation",
                  },
                }),
                _vm._v(" "),
                _c("ExecutionResultsDialog", {
                  ref: "executionResultsDialog",
                  attrs: {
                    title: "Alias Separation",
                    shouldClose: !_vm.loading,
                  },
                  on: {
                    close: function ($event) {
                      return _vm.close()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "warning",
                      disabled: _vm.matchesLocationName,
                      loading: _vm.loading,
                    },
                    on: { click: _vm.submit },
                  },
                  [
                    _c("v-icon", [_vm._v("call_split")]),
                    _vm._v("\n      Separate\n    "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      outline: "",
                      color: "secondary",
                      disabled: _vm.loading,
                    },
                    on: { click: _vm.close },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("Button.Cancel")) + "\n    "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      },
      "AppModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }